<div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden w-full">
  <!-- Answer header -->
  <div class="px-3 py-2.5 flex items-center gap-2">
    @if (data().type === 'image') {
      <app-avatar
        class="block size-8 rounded-full overflow-hidden relative shrink-0"
        [src]="getFileUrl($any(data()).value.fileId)"
        [alt]="$any(data()).value.label"
      >
        <div
          class="text-xl bg-gray-200 text-gray-400 absolute inset-0 flex items-center justify-center"
        >
          <mat-icon inline>image</mat-icon>
        </div>
      </app-avatar>
    } @else {
      <mat-icon class="text-gray-400 shrink-0 text-base/4! size-4!">
        radio_button_checked
      </mat-icon>
    }
    <span class="text-sm font-medium text-gray-900 break-words" [innerHTML]="answerLabel() | highlightVariables"></span>
  </div>

  @if (data().children.length > 0) {
    <!-- Divider -->
    <div class="border-t border-gray-100"></div>

    <!-- Action cards -->
    <div class="p-3 flex flex-col gap-2">
      @for (action of data().children; track action._id) {
        @switch (action.type) {
          @case ('speak') {
            <app-flow-speak-action [data]="$any(action)" />
          }
          @case ('audio') {
            <app-flow-audio-action [data]="$any(action)" />
          }
          @case ('image') {
            <app-flow-image-action [data]="$any(action)" />
          }
          @case ('notification-sms') {
            <app-flow-notification-sms-action [data]="$any(action)" />
          }
          @case ('stop') {
            <app-flow-stop-action />
          }
          @case ('goto-question') {
            <app-flow-goto-question-action
              [data]="$any(action)"
              [questionLabel]="gotoQuestionLabelMap().get($any(action).value) ?? null"
              (panToNode)="panToNode.emit($event)"
            />
          }
          @case ('goto-interaction') {
            <app-flow-goto-interaction-action
              [data]="$any(action)"
              [targetNodeId]="gotoInteractionTargetMap().get(getGotoTargetId($any(action))) ?? null"
              (panToNode)="panToNode.emit($event)"
            />
          }
        }
      }
    </div>
  }
</div>
